import React , { Component } from 'react';
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';

  

class Cookie extends Component{
  constructor(props) {
    super(props);

    this.onMove = this.onMove.bind(this);

    this.test = "this is a test";
  }

}
function CookieClicker() {
  

  function getNext(x) {
    return x+1
  }

  function buttonClick(i) {
    i++;
    document.getElementById('inc').value = i;
  }
  var i = 0;
    
    return (
      <div className="App">
        <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Cookie Clicker Simulator </strong> </div>
        <div className="content">
          {' '}
          Cookie Clicker, and other clicker games or idle games have always been the best type of game.
          <br />
          <br /> 
          However, there is one major problem with all of them: they are all far too complicated. The developers tend to saturate the game with features and displace the core mechanic.
          <br />
          <br />
          The core mechanic is of course, being button pushing.
          
        

        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>

        <header className="App-header">
          Cookies Clicked: 


          <button onclick="buttonClick()">Click Me</button>
          <input type="text" id="inc" value="0"></input>

        </header>
      </div>
    );
}
  
  export default CookieClicker;
  